module.exports = __webpack_public_path__ + "img/warning.974ac9f0.png";